// TODO: This could just be a Requirement Class where we convert stripe requirement codes to our own Requirement objects

export function stripeRequirementLookup(requirement) {
    if (requirement.startsWith('company')) {
        if (requirement === 'company.verification.document') {
            return { title: 'Company Verification Document', category: 'company' };
        } else {
            return { title: 'Company Details (Other)', category: 'company' };
        }
    } else if (requirement.startsWith('person_')) {
        const code = requirement.slice(requirement.indexOf('.') + 1, requirement.length);

        switch (code) {
            case 'verification.document':
                return { title: 'Identification Document', category: 'person' };

            case 'verification.additional_document':
                return { title: 'Address Verification Document', category: 'person' };

            case 'verification.proof_of_liveness':
                return { title: 'Proof of Liveness', category: 'person' };

            default:
                return { title: 'Individual Details (Other)', category: 'person' };
        }
    } else if (requirement.startsWith('interv_')) {
        // Note: these codes can have .support and .document appended to them. We treat them the same right now.
        if (requirement.includes('supportability_rejection_appeal')) {
            return { title: 'Supportability Rejection', category: 'risk' };
        } else if (requirement.includes('business_model_verification')) {
            return { title: 'Business Modal Verification', category: 'risk' };
        } else if (requirement.includes('other_supportability_inquiry')) {
            return { title: 'Other Supportability Inquiry', category: 'risk' };
        } else {
            return { title: 'Risk Verification (Other)', category: 'risk' };
        }
    } else if (requirement.startsWith('documents')) {
        if (requirement === 'documents.proof_of_registration.files') {
            return { title: 'Proof of Registration', category: 'company' };
        } else if (requirement === 'documents.ownership_verification.files') {
            return { title: 'Ownership Verification', category: 'company' };
        } else {
            return { title: 'Documents (Other)', category: 'other' };
        }
    } else if (requirement.startsWith('tos_acceptance')) {
        return { title: 'Service Agreement', category: 'tos' };
    } else {
        return { title: 'Other', category: 'other' };
    }
}
